export function isMobile(): boolean {
  return screen.width < 770
}
